export enum RemindModalModes {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
